<template>
  <div v-if="!hideFooter" class="footer-pdv" :class="{ 'd-none  d-md-block': hideFooterMobile }">
    <div class="container">
      <div class="row d-flex justify-content-between flex-row">
        <div class="col-md-11 col-10">
          <img src="/images/featured/nuevo-logo.svg" class="pdv-logo" alt="logo">
        </div>
        <div class="col-md-1 col-2" style="padding-left: 0; justify-content:flex-end;align-items:flex-start;">
          <div class="arrow-box" @click="goToTop()">
            <img src="/images/iconos/subir.png" alt="logo">
          </div>
        </div>
      </div>
      <div class="separator one"></div>
      <div class="separator second"></div>
      <div class="row">
        <div class="col-md-4 col-12 d-flex align-items-center mb-2 mb-md-0 col-footer-left">
          <div class="row">
            <div class="col-md-12 col-12">
              <p class="sub-titles">Otros Sitios PDV</p>
              <a href="https://www.preupdv.cl/alianzapdv/" target="_blank">Alianza PDV</a>
              <a href="https://www.orientachile.cl/" target="_blank">OrientaChile</a>
              <a href="https://www.evolucionapdv.cl/" target="_blank">Evoluciona</a>
              <a href="https://www.preupdv.cl/fichaspdv/" target="_blank">Fichas PDV</a>
              <!-- <button class="btn-footer" href="#">Más Información</button> -->
            </div>
            <!-- <div class="col-md-6 col-6 right-column-footer">
            </div> -->
          </div>
        </div>
        <div class="col-md-6 col-12 col-footer-middle">
          <div class="row">
            <div class="col-md-6 col-12 mb-md-0 know-us">
              <p class="sub-titles">Quienes Somos</p>
              <a :href="ruleBook" target="_blank">Reglamento PDV</a>
            </div>
            <div class="col-md-6 col-12 social-links-container">
              <p class="sub-titles">Nuestras Redes</p>
              <div class="social-container">
                <a href="https://www.facebook.com/preupdv/" target="_blank" class="social-link">
                <img src="/images/svgs/facebook.svg" class="social-link-img" alt=""/>
                </a>
                <a href="https://www.instagram.com/preupdv/" target="_blank" class="social-link">
                <img src="/images/svgs/instagram.svg" class="social-link-img" alt=""/>
                </a>
                <!--a href=" https://www.linkedin.com/company/preuniversitario-pedro-de-valdivia/?originalSubdomain=cl" target="_blank" class="social-link">
                  <img src="/images/svgs/linkedn.svg" class="social-link-img" alt=""/>
                </a>
                <a href="https://twitter.com/preupdv" target="_blank" class="social-link">
                  <img src="/images/svgs/twitter.svg" class="social-link-img" alt=""/>
                </a-->
                <a href="https://www.youtube.com/channel/UCDYsVvWgVoBjWYrEuR9KugQ" target="_blank" class="social-link">
                <img src="/images/svgs/youtube.svg" class="social-link-img" alt=""/>
                </a>
              </div>
              <div class="spacer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backPackHeader: {
      default: true
    },

    hideFooterMobile: {
      default: false
    },
    hideFooter: {
      default: false
    }
  },
  computed: {
    ruleBook() {
      return process.env.VUE_APP_PDV_RULEBOOK;
    },
  },
  methods: {
    goToTop() {
      window.scrollTo({
        top:0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
};
</script>

<style scoped lang="scss">
.footer-pdv {
  background: $black;
  // padding: 21px 0;
  padding: 0;
  position: relative;
  z-index: 10;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 565px;
  @media screen and (max-width: 430px) {
    height: 785px;
  }
  // border-top: 1px solid #000;
}

.tel-icon-footer-cont {
  width: 57px;
  height: 57px;
  border: 2px solid #000000;
  position: relative;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  span {
    display: inline-block;
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 9.5px;
    @include alternative-bold;
    padding: 0 3px;
    background: $yellow;
    color: #fff;
  }
  &:hover {
    color: #fff;
  }
}
.phone-number {
  p {
    color: #fff;
    font-size: 11px;
    @include alternative-bold;
    line-height: 13px;
    margin-bottom: 0;
  }
  a {
    color: #fff;
    font-size: 27px;
    line-height: 27px;
    margin-bottom: 0;
    @include alternative-bold;
  }
}
p{
  color: #fff;
}
a {
  color:#fff;
  display: flex !important;
  @include alternative-regular();
  font-size: 13px;
  letter-spacing: -0.06px;
  line-height: 18px;
}
.sub-titles{
  width: 100%;
  @include alternative-medium-regular();
  color:#FFD100;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 20px;
  @media screen and (max-width: 430px) {
    margin-bottom: 9px;
  }
}
.arrow-box{
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 24px;
  height: 24px;
  background: transparent;
  border-radius: 5%;
  margin-top: 13px;
  @media screen and (max-width: 430px) {
    display: none;
  }
  img{
    display: flex;
  }
}
.social-container{
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 430px) {
    margin-top: 16px;
  }
  .social-link{
    margin: 0 14px;
    &:first-child{
      margin-left: 0;
    }
  }
}
.btn-footer {
  background: transparent;
  border: #FBCE20;
  color: #FBCE20;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "ubuntubold", Arial, sans-serif;
  padding: 11.08px 14px 10.92px 14px;
  text-align: center;
  width: 134px;
  height: 40px;
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.18);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.18);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  position: relative;
  border: 1px solid #FBCE20;
  margin-top: 20px;
  -webkit-appearance: unset;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: -0.06px;
  line-height: 18px;
  text-align: center;
  border-radius: 4px;
  @media screen and (max-width: 430px) {
    margin-bottom: 77px;
  }
}
.pdv-logo{
  margin-bottom: 45.61px;
  @media screen and (max-width: 430px) {
    margin-bottom: 32px;
  }
}
@media screen and (max-width: 430px) {
  .container {
    padding-left: 33px;
  }
}
.right-column-footer{
  padding-top: 40px;
  @include media-breakpoint-down(md){
    padding-top: 57px;
  }
  @media screen and (max-width: 430px) {
    padding-top: 29px;
  }
}
.social-links-container{
  @media screen and (max-width: 430px){
    margin-top: 70px;
  }
  @media screen and (min-width: 1024px) {
    padding-left: 47px;
    .spacer{
      height: 100px;
    }
    border-left: 1px solid rgba(255,255,255,0.5);
  }
}
.separator{
  height: 161px;
  width: 1px;
  opacity: 0.25;
  background-color: #FFFFFF;
  @media screen and (max-width: 430px) {
    height: 1px;
    width: 315px;
    opacity: 0.25;
    background-color: #FFFFFF
  }
}
.separator.one {
  position: absolute;
  left: 720px;
  display: none;
  @media screen and (max-width:430px) {
    display: block;
    position: absolute;
    left: unset;
    bottom: 465px;
  }
}
.separator.second {
  display: none;
  @media screen and (max-width:430px) {
    display: block;
    position: absolute;
    top: 508px;
  }
}
.col-footer-left {
  @media screen and (min-width: 1024px){
    flex: 0 0 29%;
    border-right: 1px solid rgba(255,255,255,0.5);
  }
}
.col-footer-middle {
  @media screen and (min-width: 1024px) {
    margin-left: 35px;
  }
}
@media screen and (min-width: 1024px) {
  .know-us{
    flex: 0 0 33%;
  }
}
</style>
